module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2s"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "tra"
    }
  }), _vm._v("Note on Transliteration")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RABIC WORDS")]), _vm._v(" and phrases that appear in this book, I followed the transliteration guide of the "), _c('em', [_vm._v("International Journal of Middle East Studies")]), _vm._v(". I made an exception with regard to the Arabic names of individuals, in that I privileged the phonetic pronunciation in order to make them more accessible to an English-speaking audience. I also simplified the transliteration of well-known Arabic terms that are routinely used in English (for example, "), _c('em', [_vm._v("intifada")]), _vm._v(" or "), _c('em', [_vm._v("Al Jazeera")]), _vm._v(") using their common spelling in English-speaking contexts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94e1455e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/tra.vue
// module id = 81
// module chunks = 0